<div class="tabs is-medium is-boxed" *ngIf="isPayLaterEnabled">
  <ul>
    <li [ngClass]="{ 'is-active': isPayNowTabSelected }">
      <a (click)="setPayNow(true)">Pay Now</a>
    </li>
    <li *ngIf="!hasPartner && !isGiftCardApplied()" [ngClass]="{ 'is-active': !isPayNowTabSelected }">
      <a (click)="setPayNow(false)" data-qa-id="Pay Later">Pay Later</a>
    </li>
  </ul>
</div>

<div class="tabs-content" data-qa-id="Payment method">
  <app-pay-later-info *ngIf="!isPayNowTabSelected"></app-pay-later-info>

  <div
    *ngIf="isPayNowTabSelected"
    class="bordered-component"
    [ngClass]="{ 'bordered-component rounded-bottom-border': isPayLaterEnabled }"
  >
    <ngx-payment-form
      #ngxPaymentForm
      class="payment-form"
      [layout]="orderPaymentFormLayout"
      [totalAmount]="totalAmount"
      [ignorePaymentTypes]="ignoredPaymentTypes"
      (paymentsSelected)="onPaymentsSelected($event)"
      (formValid)="formValid.emit()"
      [(selectedPaymentType)]="selectedPaymentType"
    ></ngx-payment-form>
  </div>
</div>
